import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import {
  TypeActivityPlatform,
  TypeActivityPlatformLite,
} from '../domain/TypeActivityPlatform.model';
import { map, Observable, take } from 'rxjs';
import { ResponseApi } from '@domain/shared/infrastructure/models/response-api.interface';
import { SetMapTypeActivityPlatformLites } from '../mappers/type-activity-platform-lite.mapper';
import {
  TypeActivityPlatformApi,
  TypeActivityPlatformLiteApi,
} from './models/type-activity-platform-api.model';
import { SetMapTypeActivityPlatform } from '../mappers/type-activity-platform.mappers';
import { TypeActivityPlatformCreateOrUpdate } from '../domain/TypeActivityPlatformCreateOrUpdate.model';
import { ITypeActivityPlatformApiService } from './type-activity-platform-api.interface';

@Injectable({
  providedIn: 'root',
})
export class TypeActivityPlatformApiService
  implements ITypeActivityPlatformApiService
{
  private readonly BASE_URL = environment.baseUrl;
  private _http = inject(HttpClient);

  getAllTypeActivityPlatform(): Observable<TypeActivityPlatformLite[]> {
    const url = `${this.BASE_URL}type-activity-platform`;
    return this._http.get<ResponseApi>(url).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return [];
        return SetMapTypeActivityPlatformLites(
          response.results as TypeActivityPlatformLiteApi[]
        );
      })
    );
  }

  getTypeActivityPlatformById(
    id: number
  ): Observable<TypeActivityPlatform | null> {
    const url = `${this.BASE_URL}type-activity-platform/${id}`;
    return this._http.get<ResponseApi>(url).pipe(
      take(1),
      map((response) => {
        if (!response.ok) return null;
        return SetMapTypeActivityPlatform(
          response.results as TypeActivityPlatformApi
        );
      })
    );
  }

  createTypeActivityPlatform(
    createTypeActivity: TypeActivityPlatformCreateOrUpdate
  ): Observable<TypeActivityPlatform | null> {
    const url = `${this.BASE_URL}type-activity-platform`;
    const headers = new HttpHeaders();
    return this._http
      .post<ResponseApi>(url, createTypeActivity, { headers })
      .pipe(
        take(1),
        map((response) => {
          if (!response.ok) return null;
          return SetMapTypeActivityPlatform(
            response.results as TypeActivityPlatformApi
          );
        })
      );
  }

  updateTypeActivityPlatform(
    id: number,
    updateTypeActivity: TypeActivityPlatformCreateOrUpdate
  ): Observable<TypeActivityPlatform | null> {
    const url = `${this.BASE_URL}type-activity-platform/${id}`;
    const headers = new HttpHeaders();
    return this._http
      .put<ResponseApi>(url, updateTypeActivity, { headers })
      .pipe(
        take(1),
        map((response) => {
          if (!response.ok) return null;
          return SetMapTypeActivityPlatform(
            response.results as TypeActivityPlatformApi
          );
        })
      );
  }

  deleteTypeActivityPlatform(id: number): Observable<boolean> {
    const url = `${this.BASE_URL}type-activity-platform/${id}`;
    const headers = new HttpHeaders();
    return this._http.delete<ResponseApi>(url, { headers }).pipe(
      take(1),
      map((response) => {
        return response.ok;
      })
    );
  }
}
